/// <reference path="../include.ts" />

namespace project_guide {

	import Lang = project_common.Lang;
	import Species = project_common.Species;
	import DataParser = project_common.DataParser;

	export class SpeciesUtil {

		public static getNameFieldValue(species:Species, localLang:Lang):{ main:string, sub1:string, sub2:string, isMainScientific:boolean, isSub1Scientific:boolean, isSub2Scientific:boolean } {
			const nameLocal = DataParser.localize(species.name, localLang, false);
			const nameScientific = species.scientificName;

			let valueMain = '';
			let valueSub1 = '';
			let valueSub2 = '';

			if (localLang === Lang.en) {
				if (nameLocal) {
					valueMain = nameLocal;
					valueSub1 = nameScientific;
				} else {
					valueMain = nameScientific;
				}
			} else {
				const nameEn = DataParser.localize(species.name, Lang.en, false);
				if (nameLocal) {
					if (nameEn) {
						valueMain = nameLocal;
						valueSub1 = nameEn;
						valueSub2 = nameScientific;
					} else {
						valueMain = nameLocal;
						valueSub1 = nameScientific;
					}
				} else {
					if (nameEn) {
						valueMain = nameEn;
						valueSub1 = nameScientific;
					} else {
						valueMain = nameScientific;
					}
				}
			}

			return {
				main: valueMain,
				sub1: valueSub1,
				sub2: valueSub2,

				isMainScientific: valueMain === nameScientific,
				isSub1Scientific: valueSub1 === nameScientific,
				isSub2Scientific: valueSub2 === nameScientific,
			};
		}





		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		private constructor() {
		}
	}
}
